import { useState, useEffect } from 'react';
import { authenticatedFetch } from '../../../utils/api';
import { buildLink } from '../utils/reportHelpers';

const useGigPig = ({ reportData, settingsValues, userId, deviceInfo, logFeatureAccess }) => {
    const [uniqueData, setUniqueData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [gigPigEnabled, setGigPigEnabled] = useState([]);

    useEffect(() => {
        setGigPigEnabled(Array.from(new Set(reportData.map(item => item.gigPigLive))));
    }, [reportData]);

    const logGigpigAccess = async () => {
        await authenticatedFetch('/ManagerReport/LogGigPigAccess', {
            method: 'POST',
            body: JSON.stringify({ Metadata: deviceInfo })
        });
    };

    const handleGigpigPortal = async () => {
        const extractedData = reportData.map(item => ({
            site: item.site,
            bun: item.bun,
            baseurl: settingsValues.GigPigBaseUrl,
            email: item.hashedSiteEmail,
            token: userId
        }));
        const unique = Array.from(new Set(extractedData.map(item => JSON.stringify(item))))
            .map(item => JSON.parse(item));
        setUniqueData(unique);

        if (unique.length > 1) {
            setShowModal(true);
        } else if (unique.length === 1) {
            const openurl = buildLink(unique[0]);
            const newWindow = window.open(openurl, "_blank");
            if (newWindow !== null) {
                await logGigpigAccess();
                logFeatureAccess('BookEntertainment');
            }
        }
    };

    const handleRmSiteSelect = async (site) => {
        const openurl = buildLink(site);
        const newWindow = window.open(openurl, "_blank");
        setShowModal(false);
        if (newWindow !== null) {
            await logGigpigAccess();
            logFeatureAccess('BookEntertainment');
        }
    };

    return {
        uniqueData,
        showModal,
        setShowModal,
        gigPigEnabled,
        handleGigpigPortal,
        handleRmSiteSelect,
    };
};

export default useGigPig;
